import { render } from "./orderPlate.vue?vue&type=template&id=65faeb1e&scoped=true"
import script from "./orderPlate.vue?vue&type=script&lang=js"
export * from "./orderPlate.vue?vue&type=script&lang=js"

import "./orderPlate.vue?vue&type=style&index=0&id=65faeb1e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65faeb1e"]])

export default __exports__